import AgoraRtm from './agora-rtm'
import Tim from './tim'

export type RtmLine = 'tim' | 'rtm'

export interface RtmOptions {
  channel: string
  uid: number
  token?: string
  version?: number
}

export default class Rtm {
  public client: Tim | AgoraRtm | null = null
  public line: RtmLine | undefined

  // 初始化实例
  public async ready(line: RtmLine) {
    // 如果已有客户端，先清理旧的监听器
    if (this.client) {
      this.client.removeAllListeners()
    }

    this.line = line || 'rtm'
    this.client = null
    switch (this.line) {
      case 'rtm':
        this.client = new AgoraRtm(import.meta.env.VITE_APP_AGORA_APPID)
        break
      case 'tim':
        this.client = new Tim(import.meta.env.VITE_APP_TRTC_APPID)
        break
    }
  }

  // 登录初始化
  public init(options: RtmOptions) {
    return this.client!.init(options)
  }

  on(eventName: string | symbol, listener: (...args: any[]) => void) {
    console.log('rtm on', eventName)
    return this.client!.on(eventName, listener)
  }

  removeListener(eventName: string | symbol, listener: (...args: any[]) => void) {
    return this.client!.removeListener(eventName, listener)
  }

  // 清理所有事件监听器
  removeAllListeners() {
    if (this.client) {
      this.client.removeAllListeners()
    }
  }

  public join() {
    return this.client!.join()
  }

  public sendMessage(channel: string, message: any) {
    return this.client!.sendMessage(channel, message)
  }

  public logout() {
    return this.client!.logout()
  }

  public leave() {
    return this.client!.leave()
  }

  // 完全销毁RTM客户端
  public destroy() {
    if (this.client) {
      this.client.removeAllListeners()
      this.client = null
    }
    this.line = undefined
  }
}
